import type { VietnamProvince } from '../services/vietnam-address.service';

/**
 * Resolves a stored city/province name to the current locale label.
 */
export function translateWarehouseProvinceCityName(
  cityName: string | undefined,
  provinces: VietnamProvince[],
  lang: string,
): string {
  if (!cityName) return '';

  const province = provinces.find(
    (p) =>
      p.full_name_en === cityName ||
      p.name_en === cityName ||
      p.full_name === cityName ||
      p.name === cityName,
  );

  if (province) {
    return lang === 'vi' ? province.full_name : province.full_name_en;
  }

  return cityName;
}
